import React from "react";
import useEmpleadosLogic from "./hooks/useEmpleadosLogic";
import EmpleadosView from "./pages/EmpleadosView";

export default function Empleados() {
  const logic = useEmpleadosLogic();
  return <EmpleadosView {...logic} />;
}
